import { createSelector } from 'reselect';
import _ from 'lodash';

import { getSingleSingOnState } from './index';

export const getModifyState = createSelector(
  [getSingleSingOnState],
  ssoState => _.get(ssoState, 'modify'),
);

export const getModifyModel = createSelector(
  [getModifyState],
  stateModify => _.get(stateModify, 'model'),
);

export const getModifyStatus = createSelector(
  [getModifyModel],
  modelModify => ({
    status: _.get(modelModify, 'status'),
    msg: _.get(modelModify, 'error'),
  }),
);